export default __webpack_public_path__ + "static/media/global.bf7ff862.png";